import { useQuery, useQueryClient } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiV2ReservationElFindParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiV2ReservationElFindParams, unknown>

const fetchV2ReservationList = async (params: ApiV2ReservationElFindParams) => {
  const { data } = await apiClient.v2.apiV2ReservationElFind(params);
  return checkApiResponse(data);
}

export const v2ReservationListKeys = {
  all: [QUERY_KEY.apiV2ReservationElFind] as const,
  list: (params: ApiV2ReservationElFindParams) => [...v2ReservationListKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(v2ReservationListQueryOptions(params))` */
export const v2ReservationListQueryOptions = (params: ApiV2ReservationElFindParams) => ({
  queryKey: v2ReservationListKeys.list(params),
  queryFn: () => fetchV2ReservationList(params),
  // 날짜별 데이터 — FCM invalidation(타 사용자 변경)과 mutation invalidation(내 변경)이 커버하므로 5분 캐시
  staleTime: 5 * 60 * 1000,
  gcTime: 5 * 60 * 1000,
})

export const useV2ReservationListQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    // 선언형(DoctorColumn)도 동일한 5분 캐시 — 날짜 왕복 시 캐시 즉시 표시 + FCM/refresh 이벤트가 갱신 담당
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    queryKey: v2ReservationListKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchV2ReservationList(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}